import { Button, css, Stack, styled } from 'canoe';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import {
  InteractivePlacementPicker,
} from 'craft/containers/Toolbox/tabs/Placements/components/InteractivePlacementPicker';
import {
  ActiveStepHeader,
  StepCircle,
  StepSubtitle,
  StepTitle,
} from 'craft/containers/Toolbox/tabs/Placements/components/ui';
import { checkInvalidSelector } from 'craft/containers/Toolbox/tabs/Placements/utils';
import { setForcePlacementsTab, setPlacementMode, useCurrentSnapshot } from 'craft/state';

interface InteractivePlacementPickerProps {
  initialValue: string | undefined;
  handleConfirmPlacement: (value: string) => void;
  onCancel: () => void;
}

const StepOneContainer = styled.div`
  ${({ theme }) => css`
    margin: ${theme.spaces.xs};
  `}
`;

export const ClickToPlaceStep = ({
  initialValue,
  handleConfirmPlacement,
  onCancel,
}: InteractivePlacementPickerProps) => {
  // enforce editor placement mode here
  const dispatch = useDispatch();
  const { snapshot } = useCurrentSnapshot();

  useEffect(() => {
    dispatch(setForcePlacementsTab(true));
    dispatch(setPlacementMode(true));
    return () => {
      dispatch(setForcePlacementsTab(false));
      dispatch(setPlacementMode(false));
    };
  }, []);

  const { invalidSelector, querySelector } = checkInvalidSelector(initialValue);
  const notVisibleOnPage = !invalidSelector && !!snapshot && !querySelector && !!initialValue;

  const isForcedEdit = !initialValue || invalidSelector || notVisibleOnPage;

  return (
    <StepOneContainer>
      <Stack justify="center" space="xs">
        <ActiveStepHeader center>
          {/* only show step number when adding a selector, not when editing */}
          {!initialValue && <StepCircle>1</StepCircle>}
          <StepTitle size="short" active>
            Where will the Content go?
          </StepTitle>
          <StepSubtitle>use your mouse to choose a place.</StepSubtitle>
        </ActiveStepHeader>
      </Stack>
      <InteractivePlacementPicker
        initialValue={initialValue}
        handleConfirmPlacement={handleConfirmPlacement}
      />
      {/* only allow canceling click-to-place if a selector has already been selected and it is valid */}
      {!isForcedEdit && (
        <Button variant="neutral" appearance="outline" fullWidth onClick={onCancel}>
          Cancel
        </Button>
      )}
    </StepOneContainer>
  );
};
